import { customElement, useView, PLATFORM } from 'aurelia-framework';
import { BindingEngine } from 'aurelia-binding';
import { CustomerService, IApplicationFilter, WidgetBase, property, widget } from '@dynamik/common';
import { AgGridFilterModel, GetVouchersAgGridPageRequest, VouchersClient } from '@dynamik/common/clients/transaction-clients';
import { DocumentsClient, DocumentStateMachineStatus } from '@dynamik/common/clients/inboxv2-clients';

@customElement('welcome-widget')
@useView(PLATFORM.moduleName('./welcome-widget.html'))
@widget({ name: 'Welcome', canUseInDashboard: true, canUseInReport: false, defaultWidth: 50, defaultHeight: 15 })
export class WelcomeWidget extends WidgetBase {
  constructor(element: Element, customerService: CustomerService, bindingEngine: BindingEngine, private vouchersClient: VouchersClient, private documentsClient: DocumentsClient) {
    super(element, bindingEngine, customerService);
    this.titleFontSize = 18;
  }

  vouchersCount?: number;
  notificationsCount?: number = 0;

  @property('Text')
  font?: string;

  @property('Text')
  fontSize?: number = 16;

  @property('Text')
  fontWeight?: string;

  @property('Text')
  color?: string;

  protected override async loadData(filter: IApplicationFilter): Promise<number> {
    const documentsIds = await this.documentsClient.openDocumentIds(filter.customer.companyId, false);
    const response = await this.vouchersClient.getUnprocessedVoucherListByDocumentId(filter.customer.companyId, new GetVouchersAgGridPageRequest({
      startRow: 0,
      endRow: 1,
      documentIds: documentsIds,
      filterModel: {
        'voucher.processed': new AgGridFilterModel({ filter: 'false' }),
        'voucher.duplicates': new AgGridFilterModel({ filter: 'false' }),
        'voucher.unknownActivityType': new AgGridFilterModel({ filter: 'false' })
      }
    }));
    return response.unprocessedCount;
  }

  protected override setData(data: number): Promise<void> {
    this.vouchersCount = data;
    return Promise.resolve();
  }
}
